import Header from "../../component/users/Header";
import { useSelector } from "react-redux";
import {
  Box,
  Container,
} from "@mui/material";
import Footer from "../../component/users/Footer";
import LoaderLayout from "../../component/users/LoaderLayout";
import AddChallengeForm from "../../component/users/AddChallenge/AddChallengeForm";

const AddChallenge = () => {
  const user = useSelector((state) => state.user.loading);

  return (
    <>
      <Header />

      {user ? (
        <LoaderLayout />
      ) : (
        <Box className="userLayout addGoal">
          <Container
            disableGutters={true}
            maxWidth="lg"
            sx={{ background: "#242743" }}
          >
            <Box className="addGoal-wrapper addTournament-wrapper">
              <AddChallengeForm />
            </Box>
          </Container>
          <Footer />
        </Box>
      )}
    </>
  );
};

export default AddChallenge;
